import { render, staticRenderFns } from "./RelatorioTaxaRentabilidade.vue?vue&type=template&id=672a03b0"
import script from "./RelatorioTaxaRentabilidade.vue?vue&type=script&lang=js"
export * from "./RelatorioTaxaRentabilidade.vue?vue&type=script&lang=js"
import style0 from "./RelatorioTaxaRentabilidade.vue?vue&type=style&index=0&id=672a03b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports